module.exports = __webpack_public_path__ + "img/Streckert2019.7923542e.jpg";